import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const HeaderIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="200"
      height="52"
      viewBox="0 0 200 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1498 26.9308C23.9247 22.4863 21.6756 19.6523 18.202 19.6523C14.4624 19.6523 11.3209 22.7715 10.5957 26.9308C9.85172 31.1946 12.1253 34.0273 15.6945 34.0273C19.363 34.0273 22.4152 31.1417 23.1498 26.9308ZM20.6806 13.3876C27.1876 13.3876 31.1398 19.0026 29.7612 26.9043C28.3599 34.9371 22.524 40.2656 15.7976 40.2656C12.7379 40.2656 10.5178 39.0699 9.21776 36.9128H9.12027L7.20518 47.9872C7.11713 48.4972 6.71964 48.8983 6.21021 48.9902L1.64794 49.8119C1.00769 49.9277 0.447315 49.3699 0.559265 48.7277L6.48379 14.7085C6.56807 14.2244 7.03851 13.8283 7.52971 13.8283H12.241C12.7391 13.8283 13.0762 14.2307 12.9907 14.7218L12.6253 16.8184H12.7228C14.9146 14.5568 17.692 13.387 20.6806 13.387V13.3876Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.9422 26.8514C65.334 18.8716 71.5605 13.387 79.0907 13.387C82.6844 13.387 86.1498 14.8496 88.1246 17.715C88.3724 18.0745 88.2221 18.6298 87.8171 18.9522L84.2032 21.8245C83.7825 22.1589 83.2441 22.1129 82.9567 21.7635C81.9127 20.4916 80.3668 19.6511 78.2655 19.6511C74.38 19.6511 71.2925 22.5883 70.5579 26.8004C69.8146 31.0636 71.9498 34.0008 75.8114 34.0008C78.0039 34.0008 79.88 33.0954 81.241 31.9747C81.6322 31.6523 82.1605 31.6668 82.4435 31.9854L85.1083 34.9925C85.402 35.3243 85.3466 35.8878 84.9529 36.2385C82.3869 38.5253 78.5523 40.2656 74.0856 40.2656C66.8963 40.2656 62.5504 34.8325 63.9422 26.8514Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.888 25.5651L192.339 24.0704C192.978 24.0704 193.533 23.4074 193.388 22.8168C192.891 20.7838 191.484 19.5214 189.12 19.5214C186.88 19.5214 184.964 20.6855 183.523 22.7879C182.556 24.1963 181.765 25.9977 183.888 25.5651ZM199.593 26.5914C199.592 26.5996 199.59 26.6078 199.589 26.616C199.436 27.4874 198.751 28.1661 197.882 28.3241L183.528 30.9327C182.982 31.0365 182.489 31.7241 183.156 32.462C184.072 33.4751 184.977 34.1891 187.63 34.2111C189.831 34.2338 191.382 33.1886 192.914 31.8141C193.311 31.4584 193.879 31.4735 194.165 31.8179L196.623 34.7834C196.891 35.1071 196.843 35.6347 196.485 35.9835C193.936 38.4699 190.254 40.2656 185.745 40.2656C178.629 40.2656 174.172 34.9106 175.587 26.8004C176.965 18.8981 183.076 13.387 189.973 13.387C197.113 13.387 200.921 18.9761 199.593 26.5927V26.5914Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.0715 25.5651L107.522 24.0704C108.162 24.0704 108.716 23.4074 108.572 22.8168C108.075 20.7838 106.668 19.5214 104.304 19.5214C102.064 19.5214 100.148 20.6855 98.7061 22.7879C97.7401 24.1963 96.9489 25.9977 99.0715 25.5651ZM114.777 26.5914C114.775 26.5996 114.774 26.6078 114.773 26.616C114.62 27.4874 113.936 28.1661 113.066 28.3241L98.7118 30.9327C98.1659 31.0365 97.6721 31.7241 98.3401 32.462C99.2558 33.4751 100.161 34.1891 102.814 34.2111C105.016 34.2338 106.566 33.1886 108.099 31.8141C108.494 31.4584 109.063 31.4735 109.348 31.8179L111.807 34.7834C112.075 35.1071 112.027 35.6347 111.669 35.9835C109.12 38.4699 105.438 40.2656 100.929 40.2656C93.813 40.2656 89.3558 34.9106 90.7703 26.8004C92.1489 18.8981 98.2596 13.387 105.157 13.387C112.297 13.387 116.105 18.9761 114.777 26.5927L114.777 26.5914Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.293 0.623779H130.018C130.511 0.623779 130.84 1.02359 130.755 1.51721L124.229 38.93C124.143 39.4236 123.674 39.8235 123.181 39.8235H118.456C117.963 39.8235 117.634 39.4236 117.72 38.93L124.246 1.51721C124.332 1.02359 124.801 0.623779 125.293 0.623779Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M170.526 24.4089L167.988 38.9563C167.902 39.45 167.433 39.8498 166.94 39.8498H162.215C161.722 39.8498 161.393 39.45 161.478 38.9563L163.712 26.1511C164.578 21.1859 163.194 19.6521 160.183 19.6521C156.88 19.6521 154.239 22.1215 153.432 26.7492L151.307 38.9299C151.221 39.4235 150.752 39.8233 150.259 39.8233H145.536C145.043 39.8233 144.714 39.4235 144.8 38.9299L149.022 14.7221C149.108 14.2285 149.577 13.8287 150.071 13.8287H154.793C155.286 13.8287 155.616 14.2285 155.529 14.7221L155.1 17.1821H155.173C157.599 14.6869 160.644 13.3867 163.631 13.3867C168.828 13.3867 171.922 16.4026 170.526 24.4089Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.5393 26.9299C53.2651 22.7706 51.2098 19.6515 47.689 19.6515C44.1928 19.6515 40.9532 22.4848 40.1783 26.9299C39.4437 31.1408 41.5154 34.0264 45.1576 34.0264C48.5337 34.0264 51.7953 31.1937 52.5393 26.9299ZM60.9123 14.7083L56.6877 38.9305C56.6022 39.4216 56.1242 39.8239 55.6261 39.8239H51.2311C50.7406 39.8239 50.4079 39.4279 50.4928 38.9437L50.8877 36.6784H50.7657C48.6865 38.9922 46.011 40.2647 42.8802 40.2647C36.1519 40.2647 32.1745 34.9362 33.5758 26.9041C34.9544 19.0017 40.8645 13.3867 47.3739 13.3867C50.2387 13.3867 52.5406 14.5314 53.9469 16.7672H54.0443L54.4311 14.5484C54.5041 14.1322 54.8645 13.8287 55.2865 13.8287H60.1739C60.6645 13.8287 60.9972 14.2247 60.9123 14.7083Z"
        fill={props.fill}
      />
      <mask
        id="mask0_40171_137276"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="131"
        y="12"
        width="11"
        height="28"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M135.338 15.3873C135.112 16.683 135.701 17.9322 136.735 18.6097L135.959 23.0416C134.757 23.3268 133.778 24.3008 133.552 25.5966C133.324 26.8924 133.914 28.1415 134.948 28.8184L134.113 33.5922C132.91 33.8774 131.931 34.8514 131.705 36.1472C131.401 37.8837 132.56 39.5383 134.295 39.8418C136.03 40.1465 137.682 38.9855 137.986 37.249C138.213 35.9533 137.623 34.7041 136.588 34.0266L137.425 29.2534C138.627 28.9682 139.605 27.9942 139.833 26.6984C140.059 25.402 139.469 24.1535 138.435 23.4754L139.212 19.0435C140.414 18.7589 141.393 17.7855 141.62 16.4885C141.923 14.7526 140.764 13.0986 139.03 12.7938C138.844 12.7611 138.658 12.7454 138.475 12.7454C136.955 12.7454 135.61 13.8371 135.338 15.3873Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_40171_137276)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M135.338 15.3873C135.112 16.683 135.701 17.9322 136.735 18.6097L135.959 23.0416C134.757 23.3268 133.778 24.3008 133.552 25.5966C133.324 26.8924 133.914 28.1415 134.948 28.8184L134.113 33.5922C132.91 33.8774 131.931 34.8514 131.705 36.1472C131.401 37.8837 132.56 39.5383 134.295 39.8418C136.03 40.1465 137.682 38.9855 137.986 37.249C138.213 35.9533 137.623 34.7041 136.588 34.0266L137.425 29.2534C138.627 28.9682 139.605 27.9942 139.833 26.6984C140.059 25.402 139.469 24.1535 138.435 23.4754L139.212 19.0435C140.414 18.7589 141.393 17.7855 141.62 16.4885C141.923 14.7526 140.764 13.0986 139.03 12.7938C138.844 12.7611 138.658 12.7454 138.475 12.7454C136.955 12.7454 135.61 13.8371 135.338 15.3873Z"
          fill="url(#paint0_linear_40171_137276)"
        />
      </g>
      <mask
        id="mask1_40171_137276"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="137"
        y="2"
        width="7"
        height="8"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.095 5.34722C136.791 7.08372 137.951 8.73774 139.685 9.04247C141.421 9.34658 143.073 8.18556 143.377 6.44906C143.68 4.71256 142.521 3.05854 140.787 2.7538C140.6 2.72106 140.415 2.70532 140.232 2.70532C138.713 2.70532 137.366 3.79709 137.095 5.34722Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_40171_137276)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.095 5.34722C136.791 7.08372 137.951 8.73774 139.685 9.04247C141.421 9.34658 143.073 8.18556 143.377 6.44906C143.68 4.71256 142.521 3.05854 140.787 2.7538C140.6 2.72106 140.415 2.70532 140.232 2.70532C138.713 2.70532 137.366 3.79709 137.095 5.34722Z"
          fill="url(#paint1_linear_40171_137276)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_40171_137276"
          x1="131.656"
          y1="39.8905"
          x2="141.668"
          y2="39.8905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00AEE8" />
          <stop offset="1" stopColor="#57C8EF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_40171_137276"
          x1="136.545"
          y1="8.49152"
          x2="142.827"
          y2="9.59084"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00AEE8" />
          <stop offset="1" stopColor="#57C8EF" />
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}
